var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "acc-page-holder" },
            [
              _vm.accountSummaryFlow
                ? [
                    !_vm.mobileBigAndBelow
                      ? _c("h1", [
                          _vm._v(_vm._s(_vm.$t("Account.CloseAccount.Heading")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mobileBigAndBelow && _vm.brandTemplate !== "generic_2"
                      ? _c(
                          "div",
                          { staticClass: "account-heading" },
                          [
                            _c("icon", {
                              attrs: { name: "icon-close-account" }
                            }),
                            _vm._v(
                              _vm._s(_vm.$t("Account.CloseAccount.Heading"))
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.accountSummaryFlow
                ? [
                    _c("h1", { key: "ca_CloseAcc" }, [
                      _vm._v(_vm._s(_vm.$t("Account.CloseAccount.Heading")))
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "close-account close-account-page ctsform acc-page"
                },
                [
                  _vm.isAccountClosable
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("Account.CloseAccount.Closable.Desc"))
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isAccountClosable
                    ? _c("span", [
                        _vm.isPendingInvestigation
                          ? _c("span", { staticClass: "errfromserver" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.CloseAccount.NotClosable.PendingInvestigation.Desc"
                                  )
                                )
                              )
                            ])
                          : _vm.isSuspended
                          ? _c("span", { staticClass: "errfromserver" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.CloseAccount.NotClosable.Suspended.Desc"
                                  )
                                )
                              )
                            ])
                          : _c("span", { staticClass: "errfromserver" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.CloseAccount.NotClosable.Desc"
                                  )
                                )
                              )
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAccountClosable
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "control-block",
                            class: { filled: _vm.password }
                          },
                          [
                            (_vm.showPassword ? "text" : "password") ===
                            "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    }
                                  ],
                                  attrs: {
                                    id: "password",
                                    autocomplete: "off",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.password)
                                      ? _vm._i(_vm.password, null) > -1
                                      : _vm.password
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.password,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.password = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.password = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.password = $$c
                                      }
                                    }
                                  }
                                })
                              : (_vm.showPassword ? "text" : "password") ===
                                "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    }
                                  ],
                                  attrs: {
                                    id: "password",
                                    autocomplete: "off",
                                    type: "radio"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.password, null)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.password = null
                                    }
                                  }
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    }
                                  ],
                                  attrs: {
                                    id: "password",
                                    autocomplete: "off",
                                    type: _vm.showPassword ? "text" : "password"
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.password = $event.target.value
                                    }
                                  }
                                }),
                            _vm._v(" "),
                            !_vm.errorMessages.passwordMissing
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "show_hide",
                                    class: {
                                      show_hide_hidden: _vm.showPassword
                                    },
                                    on: { click: _vm.toggleShowPassword }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.showPassword ? "Hide" : "Show")
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                key: "password_label",
                                staticClass: "control-label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Account.CloseAccount.Password")
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm.errorMessages.passwordMissing
                            ? _c(
                                "div",
                                {
                                  key: "ca_password_error",
                                  staticClass: "vmsg invalid",
                                  attrs: { id: "err_msg_password_missing" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.CloseAccount.ErrorMessages.Password"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "save-container" },
                          [
                            _vm.isCloseAccountConfirmationPopupEnabled
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "primary-btn",
                                    attrs: {
                                      color: "success",
                                      "x-large": "",
                                      disabled:
                                        _vm.errorMessages.passwordMissing
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        _vm.dialogAccClose = true
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("Account.CloseAccount"))
                                      )
                                    ])
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    staticClass: "primary-btn",
                                    attrs: {
                                      color: "success",
                                      "x-large": "",
                                      id: "btn_closeAccount",
                                      disabled:
                                        _vm.errorMessages.passwordMissing
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.save()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("Account.CloseAccount"))
                                      )
                                    ])
                                  ]
                                )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.isCloseAccountConfirmationPopupEnabled
            ? _c(
                "v-dialog",
                {
                  attrs: { "content-class": "acc-close-conf" },
                  model: {
                    value: _vm.dialogAccClose,
                    callback: function($$v) {
                      _vm.dialogAccClose = $$v
                    },
                    expression: "dialogAccClose"
                  }
                },
                [
                  _c("div", { staticClass: "acc-close-confirmation" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Account.CloseAccount.Dialog.Title"))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { id: "btn_cancelAccount" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.dialogAccClose = false
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Account.Cancel")))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { id: "btn_closeAccount" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.save()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Account.Yes")))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ProcessingDialog",
            {
              attrs: {
                isDialogPersistent: true,
                isProcessing: _vm.isProcessing,
                isSuccess: !_vm.transactionError,
                showSuccessTextInHtml: true,
                processingTitle: _vm.$t(
                  "Account.CloseAccount.Dialog.Processing.Title"
                ),
                processingText: _vm.$t(
                  "Account.CloseAccount.Dialog.Processing.Text"
                ),
                successTitle: _vm.$t(
                  "Account.CloseAccount.Dialog.Success.Title"
                ),
                successText: _vm.$t("Account.CloseAccount.Dialog.Success.Text"),
                errorTitle: _vm.$t("Account.CloseAccount.Dialog.Error.Title"),
                closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
              },
              on: {
                close: function($event) {
                  return _vm.logout()
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
                _vm.brandKey !== "sb"
                  ? _c(
                      "p",
                      { staticClass: "generic-icon-note" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: "error" } },
                          [_vm._v("error")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.CloseAccount.Dialog.Error.Text")
                            )
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "response-error" }, [
                  _vm._v(_vm._s(_vm.transactionError))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.CloseAccount.Dialog.Error.Text.ContactSupport"
                      )
                    )
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _vm.brandTemplate === "generic_2"
            ? _c(
                "div",
                { staticClass: "acc_page_bgr_img" },
                [_c("icon", { attrs: { name: "icon-close-account" } })],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a5834e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a5834e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountCloseAccountComponent.vue
// module id = null
// module chunks = 